// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"267":"a0d418a2","881":"d114aeda","948":"6700d6ab"}[chunkId] + ".css";
};